import confetti from 'canvas-confetti'

// Confetti palette — Phoenix-orange anchor plus emerald (the
// correct-letter tile colour) and amber (present-letter) so the
// confetti reads as a direct callback to a Wordle board. Pink at the
// end keeps the burst from looking mono-tone if all three primaries
// land in the same arc.
const COLORS = ['#f97316', '#10b981', '#eab308', '#fbbf24', '#ec4899']

// Win celebration — twin angled bursts from the bottom corners plus a
// softer mid-air follow-up ~300ms later for an applause feel. Reused
// across surfaces (Wordle, future game wins, and the Settings →
// Developer test action). `disableForReducedMotion: true` opts out
// cleanly on accessibility settings without us having to read the
// media query ourselves.
export function fireWinCelebration() {
  if (typeof window === 'undefined') return
  const base = {
    colors: COLORS,
    disableForReducedMotion: true,
    ticks: 200,
  }
  confetti({ ...base, particleCount: 80, spread: 70, origin: { x: 0.15, y: 0.95 }, angle: 60, startVelocity: 55 })
  confetti({ ...base, particleCount: 80, spread: 70, origin: { x: 0.85, y: 0.95 }, angle: 120, startVelocity: 55 })
  window.setTimeout(() => {
    confetti({ ...base, particleCount: 60, spread: 110, origin: { x: 0.5, y: 0.7 }, startVelocity: 35 })
  }, 300)
}
